import React from "react";
import SpinningCircles from "../../shared/svg-icons/SpinningCircles";

const MiniLoader = ({ size = 40, color = "#003366" }) => (
  <SpinningCircles width={size} height={size} color={color} />
);

export default MiniLoader;
